// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import 'choices.js/public/assets/scripts/choices.min.js';

export default class SelectDesign extends WebComponent {
  didMount() {
    const selectWidth = this.element.getBoundingClientRect().width;
    if (this.element.tagName === 'SELECT') {

      const choices = new Choices(this.element, {
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: '',
        classNames: {
          containerOuter: 'choices category-filter__group category-filter__group--choices',
        },
        /*callbackOnInit() {
          // product detail
          const pd = document.querySelector('.product-detail');
          if (pd) {
            //console.log(this);
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            // setting same width of the dropdown to a parent sibling node
            if (viewportWidth < 737) {
              this.containerInner.element.style.width = viewportWidth - 30 + 'px';
            } else {
              this.containerInner.element.style.width = this.choiceList.element.getBoundingClientRect().width + 2 + 'px';
            }

            // adding class for gradient if more than 7 items
            /!*const items = this.config.choices.length;
            if(items > 6){
              this.choiceList.element.classList.add('choices__list--gradient');
            }*!/

            // remove scrolling when select opened
            const body = document.querySelector('body');
            this.choiceList.element.addEventListener('touchmove', function () {
              //console.log('touch');
              body.classList.add('choices--scroll');
              body.removeEventListener('scroll', body);
            });
          }
        },*/
      });
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/components/SelectDesign.js